module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/banner-8f3827394b58435a53d27e3918d693b1.png";